import React, { FC } from "react";
import { Button, Modal, Typography } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";

type ConfirmationModalProps = {
  open: boolean;
  title: string;
  handleCancel: () => void;
  handleSave: () => void;
  handleClose: () => void;
  isLoading?: boolean;
  content?: any;
  width?: any;
};

const { Text } = Typography;

const ConfirmationModal: FC<ConfirmationModalProps> = (props) => {
  return (
    <Modal
      open={props?.open}
      onCancel={props?.handleClose}
      footer={null}
      bodyStyle={{ textAlign: "center" }}
      width={props?.width ? props?.width : props?.content ? 5000 : 520}
      zIndex={2500}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "2px solid rgb(0, 76, 143)",
          borderRadius: "50%",
          padding: "6px",
          boxShadow: "0 24px 24px rgba(0, 0, 0, 0.15)",
          backgroundColor: " #ffffff",
          marginBottom: "8px",
        }}
      >
        <CheckOutlined style={{ fontSize: "14px", color: "rgb(0, 76, 143)" }} />
      </div>
      <Title level={4} style={{ marginTop: 16 }}>
        CONFIRM
      </Title>
      <Text
        style={{ display: "block", marginBottom: 24, whiteSpace: "pre-line" }}
      >
        {props?.title}
      </Text>
      {props.content && <div style={{ marginBottom: 24 }}>{props.content}</div>}
      <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          onClick={props?.handleCancel}
          loading={props?.isLoading}
          type="default"
          style={{
            borderColor: "#004C8F",
            color: "#004C8F",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
        >
          NO
        </Button>
        <Button
          onClick={props?.handleSave}
          type="primary"
          style={{
            backgroundColor: "#004C8F",
            color: "#fff",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
          loading={props?.isLoading}
        >
          YES
        </Button>

        <Button
          onClick={props?.handleClose}
          style={{
            width: 100,
            borderColor: "#d9d9d9",
            color: "#555",
            backgroundColor: "#fff",
            boxShadow: "0px 2px 8px 0px #00000020",
          }}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
